import { Pipe, PipeTransform } from '@angular/core';

import { DataPoint, Record } from '@mtna/data-core-ui';
import { Code, Variable } from '@mtna/pojo-consumer-ui';

import { RdsCodeDisplayType } from '../core/models/code-display-type.model';

@Pipe({
  name: 'rdsGetRecordValue'
})
export class RdsGetRecordValuePipe implements PipeTransform {
  transform(type: RdsCodeDisplayType, record: Record, variable: Variable): any {
    if (!record || !variable) {
      return null;
    }
    const dataPoint: DataPoint = record.data.find(d => d.value.variable.uri === variable.uri);
    if (!dataPoint) {
      return '';
    }
    const value = dataPoint.value.value;

    if (this.isCode(value)) {
      switch (type) {
        case 'NAME':
          return value.name;
        case 'VALUE':
          return value.codeValue;
        default:
          return `${value.codeValue}: ${value.name}`;
      }
    } else {
      return value;
    }
  }

  private isCode(arg: any): arg is Code {
    return arg !== undefined && arg.codeValue !== undefined && arg.uri !== undefined;
  }
}
